import React from 'react';
import { Button, PRIMARY, TERTIARY } from '@glu/buttons-react';
import PropTypes from 'prop-types';
import withLocale from '../withLocale/withLocale';

const PromptContent = ({ classes, locale, onCancel, onConfirm, styles }) => {
  return (
    <div>
      <div>
        <p>
          {locale['newUser.modal.areYouSureLivePage']} <br />
          {locale['newUser.modal.changesWillBeLost']}
        </p>
      </div>
      <div>
        <Button
          className="btn btn-primary"
          onClick={onConfirm}
          data-qa="route-guard-leave"
          text={locale['common.leave']}
          variant={PRIMARY}
        />
        <Button
          className="btn btn-tertiary"
          onClick={onCancel}
          data-qa="route-guard-cancel"
          text={locale['common.cancel']}
          variant={TERTIARY}
        />
      </div>
    </div>
  );
};

PromptContent.propTypes = {
  locale: PropTypes.objectOf(PropTypes.string),
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func
};
PromptContent.defaultProps = {
  locale: PropTypes.objectOf(PropTypes.string),
  onCancel() {},
  onConfirm() {}
};

export default withLocale(PromptContent);
